<button
  type="button"
  [ngClass]="{'flex text-gray-600':true, 'absolute px-2 pt-2 pb-1 bottom-0 ':dialogPosition === 'right', 'underline py-1 hover:text-primary-green':dialogPosition === 'below'}"
  variant="link"
  (click)="openDialog.emit()"
>
  <!-- Dialog (right side of label) -->
  @if (dialogPosition === 'right') {
  <pax-icon name="info_circle" containerClass="h-4 w-4 p-[1px]"></pax-icon>
  <span class="sr-only"
    ><span i18n>Dialog mit weiteren Informationen öffnen:</span>{{label}}</span
  >
  }

  <!-- Dialog (below label) -->
  @if (dialogPosition === 'below') { {{ label }} }
</button>
